export default {
  init() {
    // JavaScript to be fired
  },
  finalize() {
    // JavaScript to be fired, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/globalSearch.js